import { render, staticRenderFns } from "./MainPlaces.vue?vue&type=template&id=0d1b653e&"
import script from "./MainPlaces.vue?vue&type=script&lang=js&"
export * from "./MainPlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports